import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6af624c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outcome-tile text-center" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]

import { CmsGoalData } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'outcome-tile',
  props: {
    outcome: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.outcome.image.url,
        alt: _unref(cms).asText(_ctx.outcome.full_title),
        class: "outcome-img",
        "data-test": "outcome-tile-img"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("h2", {
      class: "tile-outcome-title",
      innerHTML: _unref(cms).asHtml(_ctx.outcome.name),
      "data-test": "outcome-tile-name"
    }, null, 8, _hoisted_4)
  ]))
}
}

})